<template>
    <master-layout>

        <!-- Breadcamb -->
        <div v-if="deal.id">
            <div class="breadcamb_box m-0">
                <div>
                    <h4 class="page-title"><i class="icon-directions"></i> {{ $t('deal') }}</h4>
                </div>
                <div class="t_right">
                    <div class="clearfix m-b-5">
                        <pml-back-button></pml-back-button>
                    </div>
                </div>
            </div>
            <div class="breadcamb_box bread_buttons align_itens_top">
                <div>
                    <ol class="breadcrumb p-t-0">
                        <li><router-link :to="{ name: 'deals.index' }">{{ $t('deals') }}</router-link></li>
                        <li><router-link :to="{ name: 'leads.show', params: { id: lead.id } }">{{ lead.full_name }}</router-link></li>
                        <li class="active">#{{ deal.code }} </li>
                    </ol>
                </div>
                <div>
                    <button class="m-b-5 btn btn-warning waves-light" @click.prevent="fetch()">
                        <span class="btn-label"><i class="fa fa-refresh" :class="{ 'fa-spin': isFetching }"></i></span> {{ $t('refresh') }}
                    </button>
                    <router-link :to="{ name: 'leads.show', params: { id: lead.id } }" class="m-b-5 btn btn-primary waves-light" @click.prevent="fetch()">
                        <span class="btn-label"><i class="ti-user" :class="{ 'fa-spin': isFetching }"></i></span> {{ $t('see_lead') }}
                    </router-link>
                </div>
            </div>
        </div>

        <div class="box_contents" v-if="deal.id">
            <PmlPipeline :deal="deal"></PmlPipeline>
        </div>
        <div v-if="deal.id" class="box_infos_right">
            <div class="box_contents">
                <PmlDeal :deal="deal"></PmlDeal>
                <PmlLead :lead="lead"></PmlLead>
            </div>
            <div class="box_contents">
                <div class="search-result-box">
                    <ul class="nav nav-tabs menu_deals">
                        <router-link tag="li" :to="{ name: 'deals.show.follow-ups', params: { id: deal.id } }">
                            <a><i class="fa fa-history"></i> <b class="show m-t-5 hidden-xs">{{ $t('follow_ups') }}</b></a>
                        </router-link>
                        <router-link tag="li" :to="{ name: 'deals.show.quotations', params: { id: deal.id } }">
                            <a>
                                <i class="fa fa-pencil"></i>
                                <span class="badge badge-primary" v-if="sentQuotations > 0">{{ sentQuotations }}</span>
                                <b class="show m-t-5 hidden-xs">{{ $t('quotations') }}</b>
                            </a>
                        </router-link>
                        <router-link tag="li" :to="{ name: 'deals.show.tasks', params: { id: deal.id } }">
                            <a>
                                <i class="fa fa-tasks"></i>
                                <span class="badge badge-primary" v-if="pendingTasks > 0">{{ pendingTasks }}</span>
                                <b class="show m-t-5 hidden-xs">{{ $t('tasks') }}</b>
                            </a>
                        </router-link>
                        <router-link tag="li" :to="{ name: 'deals.show.emails', params: { id: deal.id } }">
                            <a>
                                <i class="fa fa-envelope-o"></i> 
                                <span class="badge badge-primary" v-if="scheduledRecords.length > 0">{{ scheduledRecords.length }}</span>
                                <b class="show m-t-5 hidden-xs">{{ $t('emails') }}</b>
                            </a>
                        </router-link>
                        <router-link tag="li" :to="{ name: 'deals.show.attachments', params: { id: deal.id } }">
                            <a><i class="fa fa-file-text"></i> <b class="show m-t-5 hidden-xs">{{ $t('attachments') }}</b></a>
                        </router-link>
                    </ul>
                    <div class="tab-content p-0">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>
    </master-layout>
</template>

<script>
    import bus from 'utils/events/bus'
    import PmlDeal from './profile/Main.vue'
    import PmlPipeline from './Pipeline.vue'
    import PmlLead from '../../../leads/components/show/profile/Main.vue'
    import { mapGetters, mapActions } from 'vuex'
    import { filter } from 'lodash'

    export default {
        name: 'Deal',
        components: { PmlDeal, PmlLead, PmlPipeline },
        data () {
            return {
                isFetching: false
            }
        },
        metaInfo () {
            return {
                title: this.lead.name
            }
        },
        created () {
            bus.$on('fetchDeal', this.fetch)
            this.fetch()
        },
        beforeDestroy () {
            bus.$off('fetchDeal')
            this.clearDeal()
        },
        computed: {
            ...mapGetters({
                'deal': 'getDealInfo',
                'lead': 'getLeadInfo',
                'tasks': 'getDealTasks',
                'quotations': 'getDealQuotations',
                'emails': 'getDealEmails'
            }),
            pendingTasks () {
                return filter(this.tasks, ['status', 'pending']).length
            },
            sentQuotations () {
                return filter(this.quotations, ['status', 'sent']).length
            },
            scheduledRecords () {
                return filter(this.emails, function (o) {
                    return o.status === 'scheduled'
                }) || []
            }
        },
        watch: {
            '$route' (val, old) {
                if (val.name.split('.')[0] === 'deals' && val.params.id !== old.params.id && typeof val.params.id !== 'undefined')
                    this.fetch()
            }
        },
        methods: {
            ...mapActions([ 'loadDeal', 'clearDeal' ]),
            fetch () {
                this.isFetching = true

                this.loadDeal(this.$route.params.id)
                    .then(() => { this.isFetching = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/Main.vue